import { render, staticRenderFns } from "./WithdrawModal.vue?vue&type=template&id=213a1ac8&scoped=true&"
import script from "./WithdrawModal.vue?vue&type=script&lang=js&"
export * from "./WithdrawModal.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawModal.vue?vue&type=style&index=0&id=213a1ac8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213a1ac8",
  null
  
)

export default component.exports